<template>
  <div
    class="w-full rounded-[32px] px-8 transition-[padding-top,margin-right] duration-300 ease-in-out [container-type:inline-size]"
    :class="[showSuggestions ? 'pt-8' : 'pt-0']"
  >
    <Transition
      @after-enter="onSuggestionsAfterEnter"
      @after-leave="onSuggestionsAfterLeave"
      @enter="onSuggestionsEnter"
      @leave="onSuggestionsLeave"
    >
      <SuggestionModeMarquee
        v-if="showSuggestions"
        :categories
        class="pb-12"
        @click="(suggestion) => $emit('suggestion-clicked', suggestion)"
      />
    </Transition>

    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { CategorizedPromptSuggestionEvent } from '~/api/shopping-assistant/types'

import SuggestionModeMarquee from '../SuggestionModeMarquee/SuggestionModeMarquee.vue'

defineProps<{
  showSuggestions: boolean
  categories: CategorizedPromptSuggestionEvent['categories']
}>()

defineEmits<{ 'suggestion-clicked': [suggestion: string] }>()

const ANIMATION_DURATION = 300

function onSuggestionsEnter(el: Element) {
  const htmlEl = el as HTMLElement
  htmlEl.style.height = '0'
  htmlEl.style.overflow = 'hidden'
  void htmlEl.offsetHeight
  htmlEl.style.transition = `height ${ANIMATION_DURATION}ms ease-in-out`
  htmlEl.style.height = `${htmlEl.scrollHeight}px`
}

function onSuggestionsAfterEnter(el: Element) {
  const htmlEl = el as HTMLElement
  htmlEl.style.height = ''
  htmlEl.style.overflow = ''
  htmlEl.style.transition = ''
}

function onSuggestionsLeave(el: Element) {
  const htmlEl = el as HTMLElement
  htmlEl.style.height = `${htmlEl.scrollHeight}px`
  htmlEl.style.overflow = 'hidden'
  htmlEl.style.opacity = '1'
  void htmlEl.offsetHeight
  htmlEl.style.transition = `height ${ANIMATION_DURATION}ms ease-in-out, opacity ${ANIMATION_DURATION / 2}ms ease-in`
  htmlEl.style.height = '0'
  htmlEl.style.opacity = '0'
}

function onSuggestionsAfterLeave(el: Element) {
  const htmlEl = el as HTMLElement
  htmlEl.style.height = ''
  htmlEl.style.overflow = ''
  htmlEl.style.transition = ''
  htmlEl.style.opacity = ''
}
</script>
